export default function validation(response, messages, i18n, translate) {
  if (!response.data.error.validationErrors) return;
  response.data.error.validationErrors.forEach((error) => {
    let champs = 0;
    if (error.members) {
      champs = error.members[0];
      if (translate) champs = translate(i18n, champs);
    }
    const message = error.message;
    if (message !== null) {
      if (message.indexOf('Error converting value {null}') !== -1) {
        messages.push({
          message: 'addEditParution.error.champsObligatoire',
          parametres: {
            name: champs,
          },
        });
      }
      if (message.indexOf('PARUTION_PRODUIT_ID_NOT_CHANGE_IF_SALES_EXISTS') !== -1) {
        const splitMessage = message.split('|')[0].split('@');
        messages.push({
          message: 'addEditParution.error.cantModifyProduitId',
          parametres: {
            parutionCode: splitMessage[1],
          },
        });
      }
      if (message.indexOf('RATIO_INSUFFICIENT_AFTER_UPDATE') !== -1) {
        const splitMessage = message.split('|')[0].split('@');
        messages.push({
          message: 'addEditParution.error.cantModifySurface',
          parametres: {
            emplacement: splitMessage[1],
            parutionCode: splitMessage[2],
            sommeAnciensRatios: splitMessage[3],
            sommeNouveauRatios: splitMessage[4],
          },
        });
      }
      if (message.indexOf('UNABLE_TO_DELETE_PARUTION_IF_SALES_EXISTS') !== -1) {
        const splitMessage = message.split('|')[0].split('@');
        messages.push({
          message: 'addEditParution.error.deleteForbidden',
          parametres: {
            emplacement: splitMessage[1],
            parutionCode: splitMessage[2],
            sommeAnciensRatios: splitMessage[3],
            sommeNouveauRatios: splitMessage[4],
          },
        });
      }
      if (message.indexOf('PARUTION_ORDER_START_1') !== -1) {
        const splitMessage = message.split('|')[0].split('@');
        messages.push({
          message: 'addEditParution.error.orderStart1',
          parametres: {
            nomParution: splitMessage[1],
          },
        });
      }
      if (message.indexOf('PARUTION_ORDER_SUITE_NUMBER') !== -1) {
        const splitMessage = message.split('|')[0].split('@');
        messages.push({
          message: 'addEditParution.error.orderSuiteNumber',
          parametres: {
            nomParution: splitMessage[1],
          },
        });
      }
    }
  });
}
